<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_598_1648)">
      <path
        d="M15.4094 30C22.8152 30 28.8188 24.0378 28.8188 16.683C28.8188 9.32828 22.8152 3.36609 15.4094 3.36609C8.0036 3.36609 2 9.32828 2 16.683C2 24.0378 8.0036 30 15.4094 30Z"
        fill="#E7EDF0"
      />
      <path
        d="M18.3596 11.1862C18.3507 10.6358 17.564 10.4804 17.3226 10.9731C17.0589 11.5058 16.4197 12.0962 15.87 12.0962C15.1593 12.0962 14.2966 11.8609 14.2966 10.8444C14.2966 10.2096 14.5961 9.75683 15.1727 9.50825C15.9549 9.16645 16.755 8.21651 16.755 6.96028V6.32106C16.755 6.01921 16.5091 5.77063 16.2007 5.77063H14.6274C14.3234 5.77063 14.0731 6.01477 14.0731 6.32106V6.51638C14.0731 7.15115 13.7245 7.7149 13.1881 8.0567C12.236 8.66928 11.7622 9.59259 11.7622 10.8133C11.7622 12.5356 13.4741 13.9694 15.1861 13.9694C16.898 13.9694 18.2345 12.4779 18.3552 11.3371C18.3596 11.2838 18.3641 11.2306 18.3641 11.1817L18.3596 11.1862Z"
        fill="#8ED5E3"
        stroke="#061A36"
        stroke-miterlimit="10"
      />
      <path
        d="M18.3101 13.9781L20.3259 15.9801"
        stroke="#061A36"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M9.59863 15.9802L10.9396 14.6485L13.6751 11.9319C14.1534 11.4569 14.7836 11.2305 15.4094 11.2483"
        stroke="#061A36"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M10.9395 0V3.55118L12.7363 5.77067H18.6946L20.326 3.55118V0H10.9395Z"
        fill="#E7EDF0"
        stroke="#061A36"
        stroke-miterlimit="10"
      />
      <path
        d="M23.4553 17.312H6.91699V27.0778H23.4553V17.312Z"
        fill="white"
        stroke="#061A36"
        stroke-miterlimit="10"
      />
      <path
        d="M10.765 24.1436L9.59833 22.9806L8.42725 24.1436"
        stroke="#061A36"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M9.59863 23.0826V25.746"
        stroke="#061A36"
        stroke-miterlimit="10"
      />
      <path
        d="M13.8939 24.1436L12.7272 22.9806L11.5562 24.1436"
        stroke="#061A36"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M12.7275 23.0826V25.746"
        stroke="#061A36"
        stroke-miterlimit="10"
      />
      <path
        d="M13.6217 1.33167L12.2808 2.66336"
        stroke="#92949F"
        stroke-miterlimit="10"
      />
      <path
        d="M15.8567 1.33167L13.1748 3.99505"
        stroke="#92949F"
        stroke-miterlimit="10"
      />
      <path
        d="M18.0913 1.33167L14.9624 4.43895"
        stroke="#92949F"
        stroke-miterlimit="10"
      />
      <path
        d="M18.9852 2.66333L17.1973 4.43892"
        stroke="#92949F"
        stroke-miterlimit="10"
      />
      <path
        d="M17.1976 17.312H13.1748V19.5315H17.1976V17.312Z"
        fill="#8ED5E3"
        stroke="#061A36"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_598_1648">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
